import { number, object, SchemaOf, string } from "yup";
import { requiredFieldValidationMessage } from "../../Forms/ValidationMessages";
import Carrier from "../Carrier";
import { yupGsdbValidation } from "../../Forms/yupGsdbValidation";
import { nameOf } from "../../Utils/nameOf";

export const carrierSchema: SchemaOf<Carrier> = object()
  .shape({
    Name: string().required(requiredFieldValidationMessage("Name")).default(""),
    Gsdb: yupGsdbValidation(nameOf<Carrier>("Gsdb")),
    CountryId: number().notOneOf([null, 0], "Please choose a country"),
  })
  .required();
